import { bl_fi_my_einvoice_batch_pool_to_irb_link_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class EinvoiceBatchPoolToIrbLinkContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_batch_pool_to_irb_link: bl_fi_my_einvoice_batch_pool_to_irb_link_RowClass = new bl_fi_my_einvoice_batch_pool_to_irb_link_RowClass();
}